// Default Pagination values
export const PAGINATION = {
  INITIAL_PAGE: 0,
  ROWS_PER_PAGE: 25,
  ROWS_PER_PAGE_OPTIONS: [10, 25, 50, 100],
}
